
import { Component, Vue } from "vue-property-decorator";
import Kam from "@/components/common/Kam.vue";

@Component({ components: { Kam } })
export default class ContactMobile extends Vue {}
